import { GridColDef } from '@mui/x-data-grid-premium'

export const upc: GridColDef = {
	field: 'upc',
	headerName: 'UPC',
	width: 140,
	sortable: false,
}

export const year: GridColDef = {
	field: 'year',
	headerName: 'Year',
	width: 100,
	sortable: false,
}
